import * as userSelectors from './users/user.selector';
import { loderSelector } from './loader/loader.selector';
export default {
  ...userSelectors,
  loderSelector,
};
